import React, { Component } from 'react';

//componentes
import ActualizarPlani from './actualizarPlani'

class Index extends Component {

    render(){
        return(
            <div>
                <ActualizarPlani />
            </div>
        );
    }

}
export default Index;